import { Project } from "@brg/api"

const PROTECT_STATUS_TEXT = {
    0: 'not protected',
    1: 'in process',
    2: 'complete',
    3: 'canceled'
}

export enum protectProcessStatuses {
    NotStarted = 0,
    InProcess = 1,
    Complete = 2,
    Canceled = 3,
}

export const protectStatuses = {
    enabled: 0,
    disabled: 1
}

export const getProtectStatus = (project: Project<'Local'>) => {
    //@ts-ignore
    return PROTECT_STATUS_TEXT[project?.protectedStatus as number ?? 0]
}import { Project } from "@brg/api"

const PROTECT_STATUS_TEXT = {
    0: 'not protected',
    1: 'in process',
    2: 'complete',
    3: 'canceled'
}

export enum protectProcessStatuses {
    NotStarted = 0,
    InProcess = 1,
    Complete = 2,
    Canceled = 3,
}

export const protectStatuses = {
    enabled: 0,
    disabled: 1
}

export const getProtectStatus = (project: Project<'Local'>) => {
    //@ts-ignore
    return PROTECT_STATUS_TEXT[project?.protectedStatus as number ?? 0]
}